import { connect } from 'react-redux';

import { Footer, FooterProps } from '../../components/Footer/Footer';
import {
    selectCopyrightStartYear,
    selectFooterLinks
} from '../../selectors/footer/footer';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export type OwnProps = {
    cls?: string;
};

export type StateProps = TStateProps<FooterProps, OwnProps>;

export type DispatchProps = TDispatchProps<FooterProps, OwnProps>;

export const mapStateToProps = (state: State): StateProps => {
    return {
        copyrightStart: selectCopyrightStartYear(state),
        links: selectFooterLinks(state),
        tld: state.commonData.tld
    };
};

export const FooterContainer = connect<StateProps, {}, {}>(mapStateToProps)(
    Footer
);
